import { httpRequest } from '../../../../app/common/util/api-common.util';

class HistologiaAPI {
  static cancelamentoHisto(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/histo/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default HistologiaAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/histo/histo.api.js